/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { EnvConfigService } from './env-config.service';
import { ActivatedRoute } from '@angular/router';
import { MainFilterItem } from 'app/components/new-navigation/rankings/models/mainFilterItem';
import { MONTH_ARRAY_SHORT } from 'app/constants/MONTH_ARRAY';
import { toDeviceSlug } from 'app/constants/PLATFORM_SLUGS';

@Injectable()
export class BaseApiService extends EnvConfigService {
  route: ActivatedRoute;

  monthsArray = ['', ...MONTH_ARRAY_SHORT];

  qDateArray = [
    '',
    'Q1',
    'Q1',
    'Q1',
    'Q2',
    'Q2',
    'Q2',
    'Q3',
    'Q3',
    'Q3',
    'Q4',
    'Q4',
    'Q4'
  ];

  protected getMrtBaseUrl() {
    return `https://${this.getApiHost()}`;
  }
  protected getReportBaseUrl(yearPrefix = '2018') {
    return `https://${this.getApiHost()}/services/${yearPrefix}/Report`;
  }
  protected getRatingsBaseUrl(yearPrefix = '2018') {
    return `https://${this.getApiHost()}/services/${yearPrefix}/Ratings`;
  }
  protected getAlertBaseUrl(yearPrefix = '2020') {
    return `https://${this.getAlertHost()}/services/${yearPrefix}/P0`;
  }
  protected getApigeeBaseUrl(version = 'v3') {
    return `https://${this.getApigeeHost()}/api/${version}`;
  }
  protected getApiGatewayBaseUrl(version = 'v2') {
    return `https://${this.getApiGatewayHost()}/api/${version}`;
  }
  protected storeCache(res: any, dataCache: any, urlString: any) {
    if (res['status'] && res['status'] === 401) {
      // Do Nothing
    } else {
      dataCache[urlString] = JSON.parse(JSON.stringify(res));
    }
  }

  public mapToUrlParam(addParams: any) {
    const queryArr = [];
    addParams.forEach(function (value, key) {
      queryArr.push(`${key}=${value}`);
    });
    return queryArr.join('&');
  }

  protected generateFacetUrl(
    apiName: string,
    facets: string[],
    filterString: string
  ): string {
    let urlString =
      `${this.getRatingsBaseUrl()}/${apiName}?facet=` + facets.join('&facet=');
    if (filterString && filterString.length > 0) {
      urlString = urlString.concat(`&${filterString}`);
    }
    return urlString;
  }

  public getMonthOptionLabel(reportId: string, key: string) {
    let label =
      this.monthsArray[Number.parseInt(key.substring(4, 6))] +
      ' ' +
      key.substring(0, 4);
    if (reportId === 'sellerTrustIndex') {
      label =
        this.qDateArray[Number.parseInt(key.substring(4, 6))] +
        ' ' +
        key.substring(0, 4);
    }
    return label;
  }

  public getQuarterOptionLabel(key: string) {
    return (
      this.qDateArray[Number.parseInt(key.substring(4, 6))] +
      ' ' +
      key.substring(0, 4)
    );
  }

  protected getRouteParamOrFilterValue(
    route: ActivatedRoute,
    mainFilterItems: any[],
    label: string
  ) {
    const filter = mainFilterItems.find(
      filterItem => filterItem.label === label
    );
    return (
      route?.snapshot?.params[filter?.routeParam] || filter?.selected?.value
    );
  }

  public setFilterItemSelected(
    mainFilterItem: MainFilterItem,
    defaultValue?: string
  ) {
    const lookupParam = this.getFilterParam(mainFilterItem);
    if (lookupParam) {
      const foundOption = mainFilterItem.options.filter(
        option => option.value === lookupParam
      )[0];
      if (foundOption) {
        mainFilterItem.selected = foundOption;
        return;
      }
    }

    if (defaultValue) {
      const option = mainFilterItem.options.find(
        filter => filter.value == defaultValue
      );
      if (option) {
        mainFilterItem.selected = option;
        return;
      }
    }

    mainFilterItem.selected = mainFilterItem.options[0];
  }

  public getFilterParam(mainFilterItem: MainFilterItem) {
    const filterParamValue =
      this.route.snapshot.queryParams[mainFilterItem.key] ||
      this.route.snapshot.params[mainFilterItem.routeParam];
    if (
      mainFilterItem.options.filter(
        option => option.value === filterParamValue
      )[0]
    ) {
      return filterParamValue;
    }

    // Seller Trust Index links used to carry the API platform name as their
    // slug (/seller-trust-index/Amazon/...). Those links are public, so resolve
    // them rather than silently falling back to the default platform. MR-2633
    const deviceSlug = toDeviceSlug(filterParamValue as string);
    if (
      deviceSlug &&
      mainFilterItem.options.filter(option => option.value === deviceSlug)[0]
    ) {
      return deviceSlug;
    }

    if (mainFilterItem.selected) {
      return mainFilterItem.selected.value;
    } else {
      return null;
    }
  }

  public getFilterSelected(
    mainFilterItems: MainFilterItem[],
    filterKey: string,
    filterValue: string
  ) {
    const foundFilter = mainFilterItems.filter(
      item => item[filterKey] === filterValue
    )[0];
    return (
      (foundFilter && foundFilter.selected) || {
        label: undefined,
        value: undefined
      }
    );
  }
}
